<template>
    <v-dialog v-model="dialog" fullscreen persistent>
        <v-card class="d-flex flex-column h-100">
            <v-card-title class="d-flex justify-space-between align-center text-white" style="background-color: #1a5b0f !important;">
                <div class="text-truncate">
                    <div class="font-weight-bold text-h6">Uploaded Compliances</div>
                    <div class="text-caption">{{ userName }} - {{ compliance?.compliance_name }}</div>
                </div>
                <v-btn icon flat color="darkGreen" @click="dialog = false"><v-icon>mdi-close</v-icon></v-btn>
            </v-card-title>
            <v-card-text class="overflow-y-auto">
                <v-data-table :headers="headers" :items="uploads" :loading="loading" :items-per-page="15" :items-per-page-options="[15, 30, 50, 100, -1]">
                    <template v-slot:item.date_submitted="{ item }">{{ formatDate(item.date_submitted) }}</template>
                    <template v-slot:item.status="{ item }">
                        <v-chip size="small" :color="statusColor(item.file)">{{ statusText(item.file) }}</v-chip>
                    </template>
                    <template v-slot:item.files="{ item }">
                        <div v-for="file in item.file?.filenames || []" :key="file" class="my-1">
                            <v-card @click="showViewFileDialog(file)" class="file-card pa-1" density="compact" elevation="1" append-icon="mdi-open-in-new" :title="file" />
                        </div>
                    </template>
                </v-data-table>
            </v-card-text>
            <v-card-actions class="mt-auto pa-3"><v-spacer /><v-btn variant="outlined" @click="dialog = false">Close</v-btn></v-card-actions>
        </v-card>
    </v-dialog>
    <ViewFileDialog ref="ViewFileDialog" />
</template>

<script>
import axios from 'axios';
import { defineComponent } from 'vue';
import ViewFileDialog from './Sub-Dialogs/ViewFileDialog.vue';

export default defineComponent({
    components: { ViewFileDialog },
    data() {
        return {
            dialog: false,
            loading: false,
            user: null,
            compliance: null,
            uploads: [],
            headers: [
                { title: 'Course Code', key: 'facultyLoad.code', sortable: true },
                { title: 'Course Title', key: 'facultyLoad.title', sortable: true },
                { title: 'Section', key: 'facultyLoad.section_code', sortable: true },
                { title: 'Submitted Date', key: 'date_submitted', sortable: true },
                { title: 'Status', key: 'status', sortable: true },
                { title: 'Files', key: 'files', sortable: false }
            ]
        };
    },
    computed: {
        userName() {
            return this.user ? `${this.user.fname} ${this.user.lname}` : '';
        }
    },
    methods: {
        init(user, compliance) {
            this.dialog = true;
            this.user = user;
            this.compliance = compliance;
            this.loading = true;
            const token = localStorage.getItem('aums-token');
            axios.get(process.env.VUE_APP_SERVER_URL + '/compliance-upload-details/findAllComplianceUpload/' + user.id + '/' + this.$store.state.semester_schoolyear.id + '/' + compliance.id, {
                headers: { Authorization: `Bearer ${token}` }
            }).then((res) => {
                this.uploads = res.data || [];
            }).catch((error) => console.error(error)).finally(() => {
                this.loading = false;
            });
        },
        showViewFileDialog(file) {
            this.$refs.ViewFileDialog.viewFile(file);
        },
        statusText(file) {
            if (file?.approval_status === 'approved') return 'Approved';
            if (file?.approval_status === 'returned' || file?.review_status === 'returned') return 'Returned';
            if (file?.review_status === 'reviewed') return 'Reviewed';
            return 'Pending';
        },
        statusColor(file) {
            const status = this.statusText(file);
            return status === 'Approved' ? 'green' : status === 'Returned' ? 'red' : status === 'Reviewed' ? 'blue' : 'grey';
        }
    }
});
</script>

<style scoped>
.file-card :deep(.v-card-title) {
    font-size: 0.9rem;
    line-height: 1.25rem;
    padding: 0.35rem 0.5rem;
}
</style>
